package devxertech.com.pages.industries.healthCare.healthSpotLight

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.industries.common.ManagementSoftware
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun HealthSpotLight() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 45.px, bottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "THE FUTURE OF HEALTHCARE IS DIGITAL",
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 16.px,
                textAlign = TextAlign.Center
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap).margin(top = 0.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "Our More Services",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
                FieldTitleTextNormalSimple(
                    " In Spotlight",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    textTransform = TextTransform.Uppercase,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700,
                    letterSpacing = 0.5.px
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = if (breakpoint < Breakpoint.MD) 25.px else 50.px)
                    .margin(leftRight = 0.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
            ) {
                ManagementSoftware(
                    image = Res.Image.health_spot_1,
                    imageWidth = 84.px,
                    imageHeight = 84.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Insurance Claims \n" +
                            "Management",
                    description = "Insurance claims management software development is also provided by devxer to ensure " +
                            "a hassle-free, organized and a structured set-up of insurance, money transfer, financial assistance and loan applications among healthcare providers and patients."
                )
                ManagementSoftware(
                    image = Res.Image.health_spot_2,
                    imageWidth = 90.px,
                    imageHeight = 88.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Inventory Management \n" +
                            "Systems",
                    description = "Inventory management systems along with tracking orders, sales and deliveries is " +
                            "provided by devxer to enhance the final product quality by incorporating intelligent IoT and Big data solutions with least human efforts."
                )
                ManagementSoftware(
                    image = Res.Image.health_spot_3,
                    imageWidth = 100.px,
                    imageHeight = 83.px,
                    sideImage = Res.Image.inovative_common, commonChanges = true,
                    title = "Remote Diagnostics \n" +
                            "Systems",
                    description = "Remote diagnostics solutions can be custom-built or can also be made an independent " +
                            "part of the Telehealth Software to ensure a smooth flow of patient engagement and enhanced level of remote diagnosis."
                )
                ManagementSoftware(
                    image = Res.Image.health_spot_4,
                    imageWidth = 85.px,
                    imageHeight = 85.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Speech Recognition \n" +
                            "Systems",
                    description = "Speech recognition solutions by devxer are smarter, better and more innovative to " +
                            "ensure higher and more synced levels of patient engagement, quality results and effective communication."
                )
            }
        }
    }
}


